import { LuArrowRight } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import './style.css';

const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

const ProjectEstimateCTA = ({ data, projectId, useProject01Template = false }) => {
  if (!data) return null;
  return (
    <section
      className="project-estimate-cta"
      data-project-id={projectId}
      data-project-template={useProject01Template ? 'project-01' : undefined}
      aria-labelledby="project-estimate-cta-title"
    >
      <div className="project-estimate-cta__content">
        {!useProject01Template ? <p className="project-estimate-cta__eyebrow">{data.eyebrow}</p> : null}
        <h2 className="project-estimate-cta__title" id="project-estimate-cta-title">
          {data.title[0]}
          <br />
          {data.title[1]}
        </h2>
        <p className="project-estimate-cta__text">
          {data.text}
        </p>
        <Link className="project-estimate-cta__button" to={data.href}>
          <span>{data.buttonLabel}</span>
          <LuArrowRight />
        </Link>
      </div>

      <div className="project-estimate-cta__visual" aria-hidden="true">
        {!useProject01Template ? (
          <>
            <span className="project-estimate-cta__grid" />
            <span className="project-estimate-cta__points" />
            <span className="project-estimate-cta__scan-lines" />
          </>
        ) : null}
        <picture>
          <source media="(min-width: 1130px)" srcSet={data.image.preview} />
          <img src={transparentPixel} alt="" loading="lazy" />
        </picture>
      </div>
    </section>
  );
};

export default ProjectEstimateCTA;
